import { cn } from "twyne-new.ui";

import { prop, define, useCraftProp } from "@/components/builder/utils";

import ContentEditable from "../utils/ContentEditable";

import BasePreview from "./base";

function FeedbackMessagePreview({ ...props }) {
  const { value, setValue } = useCraftProp('content')

  return <BasePreview {...props}>
    <ContentEditable
      html={value}
      onChange={e => setValue(e.target.value)}
      tagName='span'
    />
  </BasePreview>
}

function FeedbackMessageHTML({ content, attributes: { className, ...attributes } }) {
  return <span className={cn("peer-user-invalid:block hidden", className)} {...attributes}>
    {content}
  </span>
}

export default define('feedback-message', FeedbackMessagePreview, FeedbackMessageHTML)
  .canSave()
  .property(prop.stylePattern())
  .property(prop.new('Content', 'content').hide().own())
  .property(prop.predefined.customClass())
  .property(...prop.predefined.typography())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(prop.predefined.letterSpacing())
  .property(prop.predefined.lineHeight())
  .property(prop.predefined.textAlign())
  .property(prop.predefined.textShadow())
  .defaultProps({
    fontSize: 'xs',
    fontWeight: 'bold',
    textColor: 'red-400',
    content: 'Field error feedback',
    space: {
      margin: 'mt-1',
    },
  })
  .build()
